module.exports = __webpack_public_path__ + "static/media/r7s2.5d0c71a7.jpg";